// This file is auto-generated by @hey-api/openapi-ts

export const AccordionElementElementModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiElementModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/AccordionElementPropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const AccordionElementPropertiesModelSchema = {
  type: 'object',
  properties: {
    title: {
      type: 'string',
      nullable: true,
    },
    textField: {
      $ref: '#/components/schemas/RichTextModel',
    },
  },
  additionalProperties: false,
} as const;

export const AccordionModuleElementModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiElementModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/AccordionModulePropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const AccordionModulePropertiesModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/PaddingSizeBasePropertiesModel',
    },
    {
      $ref: '#/components/schemas/UmbracoNavigationBasePropertiesModel',
    },
    {
      $ref: '#/components/schemas/AnchorBasePropertiesModel',
    },
  ],
  properties: {
    preHeading: {
      type: 'string',
      nullable: true,
    },
    headingTitle: {
      type: 'string',
      nullable: true,
    },
    description: {
      type: 'string',
      nullable: true,
    },
    allowOpeningMultiple: {
      type: 'boolean',
      nullable: true,
    },
    accordionElements: {
      $ref: '#/components/schemas/ApiBlockListModel',
    },
  },
  additionalProperties: false,
} as const;

export const AnchorBaseElementModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiElementModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/AnchorBasePropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const AnchorBasePropertiesModelSchema = {
  type: 'object',
  properties: {
    anchor: {
      type: 'string',
      nullable: true,
    },
    anchorDisplayName: {
      type: 'string',
      nullable: true,
    },
  },
  additionalProperties: false,
} as const;

export const ApiBlockGridAreaModelSchema = {
  type: 'object',
  properties: {
    alias: {
      type: 'string',
    },
    rowSpan: {
      type: 'integer',
      format: 'int32',
    },
    columnSpan: {
      type: 'integer',
      format: 'int32',
    },
    items: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/ApiBlockGridItemModel',
      },
    },
  },
  additionalProperties: false,
} as const;

export const ApiBlockGridItemModelSchema = {
  allOf: [
    {
      $ref: '#/components/schemas/ApiBlockItemModel',
    },
    {
      type: 'object',
      properties: {
        rowSpan: {
          type: 'integer',
          format: 'int32',
        },
        columnSpan: {
          type: 'integer',
          format: 'int32',
        },
        areaGridColumns: {
          type: 'integer',
          format: 'int32',
        },
        areas: {
          type: 'array',
          items: {
            $ref: '#/components/schemas/ApiBlockGridAreaModel',
          },
        },
      },
      additionalProperties: false,
    },
  ],
} as const;

export const ApiBlockItemModelSchema = {
  type: 'object',
  properties: {
    content: {
      $ref: '#/components/schemas/IApiElementModel',
    },
    settings: {
      $ref: '#/components/schemas/IApiElementModel',
    },
  },
  additionalProperties: false,
} as const;

export const ApiBlockListModelSchema = {
  type: 'object',
  properties: {
    items: {
      type: 'array',
      items: {
        oneOf: [
          {
            $ref: '#/components/schemas/ApiBlockItemModel',
          },
          {
            $ref: '#/components/schemas/ApiBlockGridItemModel',
          },
        ],
      },
    },
  },
  additionalProperties: false,
} as const;

export const ApiLinkModelSchema = {
  type: 'object',
  properties: {
    url: {
      type: 'string',
      nullable: true,
      readOnly: true,
    },
    queryString: {
      type: 'string',
      nullable: true,
      readOnly: true,
    },
    title: {
      type: 'string',
      nullable: true,
      readOnly: true,
    },
    target: {
      type: 'string',
      nullable: true,
      readOnly: true,
    },
    destinationId: {
      type: 'string',
      format: 'uuid',
      nullable: true,
      readOnly: true,
    },
    destinationType: {
      type: 'string',
      nullable: true,
      readOnly: true,
    },
    route: {
      $ref: '#/components/schemas/IApiContentRouteModel',
    },
    linkType: {
      $ref: '#/components/schemas/LinkTypeModel',
    },
  },
  additionalProperties: false,
} as const;

export const ArticleListingPageContentModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/ArticleListingPagePropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const ArticleListingPageContentResponseModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentResponseModelBase',
    },
    {
      $ref: '#/components/schemas/ArticleListingPageContentModel',
    },
  ],
  additionalProperties: false,
} as const;

export const ArticleListingPagePropertiesModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/BasePagePropertiesModel',
    },
  ],
  additionalProperties: false,
} as const;

export const ArticlePageContentModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/ArticlePagePropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const ArticlePageContentResponseModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentResponseModelBase',
    },
    {
      $ref: '#/components/schemas/ArticlePageContentModel',
    },
  ],
  additionalProperties: false,
} as const;

export const ArticlePagePropertiesModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/BasePagePropertiesModel',
    },
    {
      $ref: '#/components/schemas/PromoBasePropertiesModel',
    },
  ],
  properties: {
    category: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/IApiContentModel',
      },
      nullable: true,
    },
  },
  additionalProperties: false,
} as const;

export const BasePageContentModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/BasePagePropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const BasePageContentResponseModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentResponseModelBase',
    },
    {
      $ref: '#/components/schemas/BasePageContentModel',
    },
  ],
  additionalProperties: false,
} as const;

export const BasePagePropertiesModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/SEobasePropertiesModel',
    },
  ],
  properties: {
    disableBreadcrumbsOnPage: {
      type: 'boolean',
      nullable: true,
    },
    breadcrumbsLabel: {
      type: 'string',
      nullable: true,
    },
  },
  additionalProperties: false,
} as const;

export const CTabreakModuleElementModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiElementModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/CTabreakModulePropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const CTabreakModulePropertiesModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/PaddingSizeBasePropertiesModel',
    },
    {
      $ref: '#/components/schemas/UmbracoNavigationBasePropertiesModel',
    },
    {
      $ref: '#/components/schemas/AnchorBasePropertiesModel',
    },
  ],
  properties: {
    preHeading: {
      type: 'string',
      nullable: true,
    },
    headingTitle: {
      type: 'string',
      nullable: true,
    },
    primaryCTA: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/ApiLinkModel',
      },
      nullable: true,
    },
    secondaryCTA: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/ApiLinkModel',
      },
      nullable: true,
    },
    image: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/IApiMediaWithCropsModel',
      },
      nullable: true,
    },
  },
  additionalProperties: false,
} as const;

export const CategoryContentModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/CategoryPropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const CategoryContentResponseModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentResponseModelBase',
    },
    {
      $ref: '#/components/schemas/CategoryContentModel',
    },
  ],
  additionalProperties: false,
} as const;

export const CategoryFolderContentModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/CategoryFolderPropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const CategoryFolderContentResponseModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentResponseModelBase',
    },
    {
      $ref: '#/components/schemas/CategoryFolderContentModel',
    },
  ],
  additionalProperties: false,
} as const;

export const CategoryFolderPropertiesModelSchema = {
  type: 'object',
  additionalProperties: false,
} as const;

export const CategoryPropertiesModelSchema = {
  type: 'object',
  properties: {
    displayName: {
      type: 'string',
      nullable: true,
    },
  },
  additionalProperties: false,
} as const;

export const GlobalSharedContentContentModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/GlobalSharedContentPropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const GlobalSharedContentContentResponseModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentResponseModelBase',
    },
    {
      $ref: '#/components/schemas/GlobalSharedContentContentModel',
    },
  ],
  additionalProperties: false,
} as const;

export const GlobalSharedContentPropertiesModelSchema = {
  type: 'object',
  additionalProperties: false,
} as const;

export const HeroFullBleedModuleElementModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiElementModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/HeroFullBleedModulePropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const HeroFullBleedModulePropertiesModelSchema = {
  type: 'object',
  properties: {
    preHeading: {
      type: 'string',
      nullable: true,
    },
    headingTitle: {
      type: 'string',
      nullable: true,
    },
    description: {
      $ref: '#/components/schemas/RichTextModel',
    },
    backgroundMedia: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/IApiMediaWithCropsModel',
      },
      nullable: true,
    },
  },
  additionalProperties: false,
} as const;

export const HomePageContentModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/HomePagePropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const HomePageContentResponseModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentResponseModelBase',
    },
    {
      $ref: '#/components/schemas/HomePageContentModel',
    },
  ],
  additionalProperties: false,
} as const;

export const HomePagePropertiesModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/BasePagePropertiesModel',
    },
  ],
  properties: {
    pageHeadingModule: {
      $ref: '#/components/schemas/ApiBlockListModel',
    },
    pageContentModules: {
      $ref: '#/components/schemas/ApiBlockListModel',
    },
  },
  additionalProperties: false,
} as const;

export const HttpValidationProblemDetailsSchema = {
  allOf: [
    {
      $ref: '#/components/schemas/ProblemDetails',
    },
    {
      type: 'object',
      properties: {
        errors: {
          type: 'object',
          additionalProperties: {
            type: 'array',
            items: {
              type: 'string',
            },
          },
        },
      },
      additionalProperties: {},
    },
  ],
} as const;

export const IApiContentModelSchema = {
  type: 'object',
  oneOf: [
    {
      $ref: '#/components/schemas/ParentCategoryContentModel',
    },
    {
      $ref: '#/components/schemas/CategoryContentModel',
    },
    {
      $ref: '#/components/schemas/XmlSiteMapContentModel',
    },
    {
      $ref: '#/components/schemas/BasePageContentModel',
    },
    {
      $ref: '#/components/schemas/GlobalSharedContentContentModel',
    },
    {
      $ref: '#/components/schemas/RobotstxtContentModel',
    },
    {
      $ref: '#/components/schemas/SiteSettingsLayoutContentModel',
    },
    {
      $ref: '#/components/schemas/PromoBaseContentModel',
    },
    {
      $ref: '#/components/schemas/CategoryFolderContentModel',
    },
    {
      $ref: '#/components/schemas/ArticlePageContentModel',
    },
    {
      $ref: '#/components/schemas/LandingPageContentModel',
    },
    {
      $ref: '#/components/schemas/ArticleListingPageContentModel',
    },
    {
      $ref: '#/components/schemas/HomePageContentModel',
    },
  ],
  additionalProperties: false,
} as const;

export const IApiContentModelBaseSchema = {
  required: ['contentType'],
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiElementModelBase',
    },
  ],
  properties: {
    id: {
      type: 'string',
      format: 'uuid',
      readOnly: true,
    },
    contentType: {
      type: 'string',
      readOnly: true,
    },
    name: {
      type: 'string',
      nullable: true,
      readOnly: true,
    },
    createDate: {
      type: 'string',
      format: 'date-time',
      readOnly: true,
    },
    updateDate: {
      type: 'string',
      format: 'date-time',
      readOnly: true,
    },
    route: {
      $ref: '#/components/schemas/IApiContentRouteModel',
    },
  },
  additionalProperties: false,
  discriminator: {
    propertyName: 'contentType',
    mapping: {
      parentCategory: '#/components/schemas/ParentCategoryContentModel',
      category: '#/components/schemas/CategoryContentModel',
      xmlSiteMap: '#/components/schemas/XmlSiteMapContentModel',
      basePage: '#/components/schemas/BasePageContentModel',
      globalSharedContent: '#/components/schemas/GlobalSharedContentContentModel',
      robotstxt: '#/components/schemas/RobotstxtContentModel',
      siteSettingsLayout: '#/components/schemas/SiteSettingsLayoutContentModel',
      promoBase: '#/components/schemas/PromoBaseContentModel',
      categoryFolder: '#/components/schemas/CategoryFolderContentModel',
      articlePage: '#/components/schemas/ArticlePageContentModel',
      landingPage: '#/components/schemas/LandingPageContentModel',
      articleListingPage: '#/components/schemas/ArticleListingPageContentModel',
      homePage: '#/components/schemas/HomePageContentModel',
    },
  },
} as const;

export const IApiContentResponseModelSchema = {
  type: 'object',
  oneOf: [
    {
      $ref: '#/components/schemas/ParentCategoryContentResponseModel',
    },
    {
      $ref: '#/components/schemas/CategoryContentResponseModel',
    },
    {
      $ref: '#/components/schemas/XmlSiteMapContentResponseModel',
    },
    {
      $ref: '#/components/schemas/BasePageContentResponseModel',
    },
    {
      $ref: '#/components/schemas/GlobalSharedContentContentResponseModel',
    },
    {
      $ref: '#/components/schemas/RobotstxtContentResponseModel',
    },
    {
      $ref: '#/components/schemas/SiteSettingsLayoutContentResponseModel',
    },
    {
      $ref: '#/components/schemas/PromoBaseContentResponseModel',
    },
    {
      $ref: '#/components/schemas/CategoryFolderContentResponseModel',
    },
    {
      $ref: '#/components/schemas/ArticlePageContentResponseModel',
    },
    {
      $ref: '#/components/schemas/LandingPageContentResponseModel',
    },
    {
      $ref: '#/components/schemas/ArticleListingPageContentResponseModel',
    },
    {
      $ref: '#/components/schemas/HomePageContentResponseModel',
    },
  ],
  additionalProperties: false,
} as const;

export const IApiContentResponseModelBaseSchema = {
  required: ['contentType'],
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentModelBase',
    },
  ],
  properties: {
    id: {
      type: 'string',
      format: 'uuid',
      readOnly: true,
    },
    contentType: {
      type: 'string',
      readOnly: true,
    },
    name: {
      type: 'string',
      nullable: true,
      readOnly: true,
    },
    createDate: {
      type: 'string',
      format: 'date-time',
      readOnly: true,
    },
    updateDate: {
      type: 'string',
      format: 'date-time',
      readOnly: true,
    },
    route: {
      $ref: '#/components/schemas/IApiContentRouteModel',
    },
    cultures: {
      type: 'object',
      additionalProperties: {
        $ref: '#/components/schemas/IApiContentRouteModel',
      },
      readOnly: true,
    },
  },
  additionalProperties: false,
  discriminator: {
    propertyName: 'contentType',
    mapping: {
      parentCategory: '#/components/schemas/ParentCategoryContentResponseModel',
      category: '#/components/schemas/CategoryContentResponseModel',
      xmlSiteMap: '#/components/schemas/XmlSiteMapContentResponseModel',
      basePage: '#/components/schemas/BasePageContentResponseModel',
      globalSharedContent: '#/components/schemas/GlobalSharedContentContentResponseModel',
      robotstxt: '#/components/schemas/RobotstxtContentResponseModel',
      siteSettingsLayout: '#/components/schemas/SiteSettingsLayoutContentResponseModel',
      promoBase: '#/components/schemas/PromoBaseContentResponseModel',
      categoryFolder: '#/components/schemas/CategoryFolderContentResponseModel',
      articlePage: '#/components/schemas/ArticlePageContentResponseModel',
      landingPage: '#/components/schemas/LandingPageContentResponseModel',
      articleListingPage: '#/components/schemas/ArticleListingPageContentResponseModel',
      homePage: '#/components/schemas/HomePageContentResponseModel',
    },
  },
} as const;

export const IApiContentRouteModelSchema = {
  type: 'object',
  properties: {
    path: {
      type: 'string',
      readOnly: true,
    },
    startItem: {
      $ref: '#/components/schemas/IApiContentStartItemModel',
    },
  },
  additionalProperties: false,
} as const;

export const IApiContentStartItemModelSchema = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
      format: 'uuid',
      readOnly: true,
    },
    path: {
      type: 'string',
      readOnly: true,
    },
  },
  additionalProperties: false,
} as const;

export const IApiElementModelSchema = {
  type: 'object',
  oneOf: [
    {
      $ref: '#/components/schemas/AccordionElementElementModel',
    },
    {
      $ref: '#/components/schemas/PaddingSizeBaseElementModel',
    },
    {
      $ref: '#/components/schemas/UmbracoNavigationBaseElementModel',
    },
    {
      $ref: '#/components/schemas/HeroFullBleedModuleElementModel',
    },
    {
      $ref: '#/components/schemas/CTabreakModuleElementModel',
    },
    {
      $ref: '#/components/schemas/RichTextModuleElementModel',
    },
    {
      $ref: '#/components/schemas/SEobaseElementModel',
    },
    {
      $ref: '#/components/schemas/AccordionModuleElementModel',
    },
    {
      $ref: '#/components/schemas/NameModuleBaseElementModel',
    },
    {
      $ref: '#/components/schemas/AnchorBaseElementModel',
    },
  ],
  additionalProperties: false,
} as const;

export const IApiElementModelBaseSchema = {
  required: ['contentType'],
  type: 'object',
  properties: {
    id: {
      type: 'string',
      format: 'uuid',
      readOnly: true,
    },
    contentType: {
      type: 'string',
      readOnly: true,
    },
  },
  additionalProperties: false,
  discriminator: {
    propertyName: 'contentType',
    mapping: {
      accordionElement: '#/components/schemas/AccordionElementElementModel',
      paddingSizeBase: '#/components/schemas/PaddingSizeBaseElementModel',
      umbracoNavigationBase: '#/components/schemas/UmbracoNavigationBaseElementModel',
      heroFullBleedModule: '#/components/schemas/HeroFullBleedModuleElementModel',
      cTABreakModule: '#/components/schemas/CTabreakModuleElementModel',
      richTextModule: '#/components/schemas/RichTextModuleElementModel',
      sEOBase: '#/components/schemas/SEobaseElementModel',
      accordionModule: '#/components/schemas/AccordionModuleElementModel',
      nameModuleBase: '#/components/schemas/NameModuleBaseElementModel',
      anchorBase: '#/components/schemas/AnchorBaseElementModel',
    },
  },
} as const;

export const IApiMediaWithCropsModelSchema = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
      format: 'uuid',
      readOnly: true,
    },
    name: {
      type: 'string',
      readOnly: true,
    },
    mediaType: {
      type: 'string',
      readOnly: true,
    },
    url: {
      type: 'string',
      readOnly: true,
    },
    extension: {
      type: 'string',
      nullable: true,
      readOnly: true,
    },
    width: {
      type: 'integer',
      format: 'int32',
      nullable: true,
      readOnly: true,
    },
    height: {
      type: 'integer',
      format: 'int32',
      nullable: true,
      readOnly: true,
    },
    bytes: {
      type: 'integer',
      format: 'int32',
      nullable: true,
      readOnly: true,
    },
    properties: {
      type: 'object',
      additionalProperties: {
        nullable: true,
      },
      readOnly: true,
    },
    focalPoint: {
      $ref: '#/components/schemas/ImageFocalPointModel',
    },
    crops: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/ImageCropModel',
      },
      nullable: true,
      readOnly: true,
    },
  },
  additionalProperties: false,
} as const;

export const IApiMediaWithCropsResponseModelSchema = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
      format: 'uuid',
      readOnly: true,
    },
    name: {
      type: 'string',
      readOnly: true,
    },
    mediaType: {
      type: 'string',
      readOnly: true,
    },
    url: {
      type: 'string',
      readOnly: true,
    },
    extension: {
      type: 'string',
      nullable: true,
      readOnly: true,
    },
    width: {
      type: 'integer',
      format: 'int32',
      nullable: true,
      readOnly: true,
    },
    height: {
      type: 'integer',
      format: 'int32',
      nullable: true,
      readOnly: true,
    },
    bytes: {
      type: 'integer',
      format: 'int32',
      nullable: true,
      readOnly: true,
    },
    properties: {
      type: 'object',
      additionalProperties: {
        nullable: true,
      },
      readOnly: true,
    },
    focalPoint: {
      $ref: '#/components/schemas/ImageFocalPointModel',
    },
    crops: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/ImageCropModel',
      },
      nullable: true,
      readOnly: true,
    },
    path: {
      type: 'string',
      readOnly: true,
    },
    createDate: {
      type: 'string',
      format: 'date-time',
      readOnly: true,
    },
    updateDate: {
      type: 'string',
      format: 'date-time',
      readOnly: true,
    },
  },
  additionalProperties: false,
} as const;

export const ImageCropCoordinatesModelSchema = {
  type: 'object',
  properties: {
    x1: {
      type: 'number',
      format: 'double',
    },
    y1: {
      type: 'number',
      format: 'double',
    },
    x2: {
      type: 'number',
      format: 'double',
    },
    y2: {
      type: 'number',
      format: 'double',
    },
  },
  additionalProperties: false,
} as const;

export const ImageCropModelSchema = {
  type: 'object',
  properties: {
    alias: {
      type: 'string',
      nullable: true,
    },
    width: {
      type: 'integer',
      format: 'int32',
    },
    height: {
      type: 'integer',
      format: 'int32',
    },
    coordinates: {
      $ref: '#/components/schemas/ImageCropCoordinatesModel',
    },
  },
  additionalProperties: false,
} as const;

export const ImageFocalPointModelSchema = {
  type: 'object',
  properties: {
    left: {
      type: 'number',
      format: 'double',
    },
    top: {
      type: 'number',
      format: 'double',
    },
  },
  additionalProperties: false,
} as const;

export const LandingPageContentModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/LandingPagePropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const LandingPageContentResponseModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentResponseModelBase',
    },
    {
      $ref: '#/components/schemas/LandingPageContentModel',
    },
  ],
  additionalProperties: false,
} as const;

export const LandingPagePropertiesModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/PromoBasePropertiesModel',
    },
    {
      $ref: '#/components/schemas/BasePagePropertiesModel',
    },
  ],
  properties: {
    pageHeadingModule: {
      $ref: '#/components/schemas/ApiBlockListModel',
    },
    pageContentModules: {
      $ref: '#/components/schemas/ApiBlockListModel',
    },
  },
  additionalProperties: false,
} as const;

export const LinkTypeModelSchema = {
  enum: ['Content', 'Media', 'External'],
  type: 'string',
} as const;

export const NameModuleBaseElementModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiElementModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/NameModuleBasePropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const NameModuleBasePropertiesModelSchema = {
  type: 'object',
  properties: {
    cMSLabel: {
      type: 'string',
      nullable: true,
    },
  },
  additionalProperties: false,
} as const;

export const PaddingSizeBaseElementModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiElementModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/PaddingSizeBasePropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const PaddingSizeBasePropertiesModelSchema = {
  type: 'object',
  properties: {
    paddingTop: {
      type: 'string',
      nullable: true,
    },
    paddingBottom: {
      type: 'string',
      nullable: true,
    },
  },
  additionalProperties: false,
} as const;

export const PagedIApiContentResponseModelSchema = {
  required: ['items', 'total'],
  type: 'object',
  properties: {
    total: {
      type: 'integer',
      format: 'int64',
    },
    items: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/IApiContentResponseModel',
      },
    },
  },
  additionalProperties: false,
} as const;

export const PagedIApiMediaWithCropsResponseModelSchema = {
  required: ['items', 'total'],
  type: 'object',
  properties: {
    total: {
      type: 'integer',
      format: 'int64',
    },
    items: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/IApiMediaWithCropsResponseModel',
      },
    },
  },
  additionalProperties: false,
} as const;

export const ParentCategoryContentModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/ParentCategoryPropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const ParentCategoryContentResponseModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentResponseModelBase',
    },
    {
      $ref: '#/components/schemas/ParentCategoryContentModel',
    },
  ],
  additionalProperties: false,
} as const;

export const ParentCategoryPropertiesModelSchema = {
  type: 'object',
  additionalProperties: false,
} as const;

export const ProblemDetailsSchema = {
  type: 'object',
  properties: {
    type: {
      type: 'string',
      nullable: true,
    },
    title: {
      type: 'string',
      nullable: true,
    },
    status: {
      type: 'integer',
      format: 'int32',
      nullable: true,
    },
    detail: {
      type: 'string',
      nullable: true,
    },
    instance: {
      type: 'string',
      nullable: true,
    },
  },
  additionalProperties: {},
} as const;

export const PromoBaseContentModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/PromoBasePropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const PromoBaseContentResponseModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentResponseModelBase',
    },
    {
      $ref: '#/components/schemas/PromoBaseContentModel',
    },
  ],
  additionalProperties: false,
} as const;

export const PromoBasePropertiesModelSchema = {
  type: 'object',
  properties: {
    promoTitle: {
      type: 'string',
      nullable: true,
    },
    promoImage: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/IApiMediaWithCropsModel',
      },
      nullable: true,
    },
    promoDescription: {
      type: 'string',
      nullable: true,
    },
  },
  additionalProperties: false,
} as const;

export const RichTextModelSchema = {
  required: ['blocks', 'markup'],
  type: 'object',
  properties: {
    markup: {
      type: 'string',
    },
    blocks: {
      type: 'array',
      items: {
        oneOf: [
          {
            $ref: '#/components/schemas/ApiBlockItemModel',
          },
          {
            $ref: '#/components/schemas/ApiBlockGridItemModel',
          },
        ],
      },
    },
  },
  additionalProperties: false,
} as const;

export const RichTextModuleElementModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiElementModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/RichTextModulePropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const RichTextModulePropertiesModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/AnchorBasePropertiesModel',
    },
    {
      $ref: '#/components/schemas/UmbracoNavigationBasePropertiesModel',
    },
    {
      $ref: '#/components/schemas/PaddingSizeBasePropertiesModel',
    },
  ],
  properties: {
    preHeading: {
      type: 'string',
      nullable: true,
    },
    headingTitle: {
      type: 'string',
      nullable: true,
    },
    content: {
      $ref: '#/components/schemas/RichTextModel',
    },
    primaryCTA: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/ApiLinkModel',
      },
      nullable: true,
    },
    secondaryCTA: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/ApiLinkModel',
      },
      nullable: true,
    },
  },
  additionalProperties: false,
} as const;

export const RobotstxtContentModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/RobotstxtPropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const RobotstxtContentResponseModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentResponseModelBase',
    },
    {
      $ref: '#/components/schemas/RobotstxtContentModel',
    },
  ],
  additionalProperties: false,
} as const;

export const RobotstxtPropertiesModelSchema = {
  type: 'object',
  properties: {
    disallowAll: {
      type: 'boolean',
      nullable: true,
    },
    disallowedURLs: {
      type: 'array',
      items: {
        type: 'string',
      },
      nullable: true,
    },
    disallowedSearchEngines: {
      type: 'array',
      items: {
        type: 'string',
      },
      nullable: true,
    },
    crawlDelayForSearch: {
      $ref: '#/components/schemas/ApiBlockListModel',
    },
    sitemapURLs: {
      type: 'array',
      items: {
        type: 'string',
      },
      nullable: true,
    },
    imageSitemapURLs: {
      type: 'array',
      items: {
        type: 'string',
      },
      nullable: true,
    },
  },
  additionalProperties: false,
} as const;

export const SEobaseElementModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiElementModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/SEobasePropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const SEobasePropertiesModelSchema = {
  type: 'object',
  properties: {
    pageTitle: {
      type: 'string',
      nullable: true,
    },
    metaDescription: {
      type: 'string',
      nullable: true,
    },
    openGraphTitle: {
      type: 'string',
      nullable: true,
    },
    openGraphDescription: {
      type: 'string',
      nullable: true,
    },
    openGraphImage: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/IApiMediaWithCropsModel',
      },
      nullable: true,
    },
    hideFromSearch: {
      type: 'boolean',
      nullable: true,
    },
    structuredDataThirdPartyTags: {
      type: 'string',
      nullable: true,
    },
    searchEngineChangeFrequency: {
      type: 'string',
      nullable: true,
    },
    hideFromXmlSitemap: {
      type: 'boolean',
      nullable: true,
    },
    searchEngineRelativePriority: {
      type: 'number',
      format: 'double',
      nullable: true,
    },
  },
  additionalProperties: false,
} as const;

export const SiteSettingsLayoutContentModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/SiteSettingsLayoutPropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const SiteSettingsLayoutContentResponseModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentResponseModelBase',
    },
    {
      $ref: '#/components/schemas/SiteSettingsLayoutContentModel',
    },
  ],
  additionalProperties: false,
} as const;

export const SiteSettingsLayoutPropertiesModelSchema = {
  type: 'object',
  properties: {
    socialLinks: {
      $ref: '#/components/schemas/ApiBlockListModel',
    },
    defaultOpenGraphImage: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/IApiMediaWithCropsModel',
      },
      nullable: true,
    },
    siteLogo: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/IApiMediaWithCropsModel',
      },
      nullable: true,
    },
    cookieNoticeMessage: {
      $ref: '#/components/schemas/RichTextModel',
    },
    headSectionScripts: {
      type: 'string',
      nullable: true,
    },
    bodySectionScripts: {
      type: 'string',
      nullable: true,
    },
    enableBreadcrumbs: {
      type: 'boolean',
      nullable: true,
    },
    breadcrumbsShouldContainHome: {
      type: 'boolean',
      nullable: true,
    },
    favicon: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/IApiMediaWithCropsModel',
      },
      nullable: true,
    },
  },
  additionalProperties: false,
} as const;

export const UmbracoNavigationBaseElementModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiElementModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/UmbracoNavigationBasePropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const UmbracoNavigationBasePropertiesModelSchema = {
  type: 'object',
  properties: {
    umbracoNaviHide: {
      type: 'boolean',
      nullable: true,
    },
  },
  additionalProperties: false,
} as const;

export const XmlSiteMapContentModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentModelBase',
    },
  ],
  properties: {
    properties: {
      $ref: '#/components/schemas/XmlSiteMapPropertiesModel',
    },
  },
  additionalProperties: false,
} as const;

export const XmlSiteMapContentResponseModelSchema = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/IApiContentResponseModelBase',
    },
    {
      $ref: '#/components/schemas/XmlSiteMapContentModel',
    },
  ],
  additionalProperties: false,
} as const;

export const XmlSiteMapPropertiesModelSchema = {
  type: 'object',
  properties: {
    excludedDocumentTypes: {
      type: 'string',
      nullable: true,
    },
    isImageSiteMap: {
      type: 'boolean',
      nullable: true,
    },
  },
  additionalProperties: false,
} as const;
